import * as types from './settings.types';

export const settingsPageSelectors: types.ISettingsPageSelectors = {
  selectIsFetched: (state) => state.page.settings.isFetched,
};
